import { Controller } from '@hotwired/stimulus'

export default class extends Controller {

  remove(event) {
    const frame = event.currentTarget.closest('turbo-frame');
    frame.src = ''
    frame.innerHTML = '';
  }
}